export default __webpack_public_path__ + "static/media/dole-lemonade-bg-tablet@2x.64a2fd0d.png";